// @flow
import React, { useState } from 'react';
import Slider from 'react-slick';
import { Image } from 'components/atoms/image';
import { useViewport } from 'components/templates/viewportProvider';
import { PaginationControl } from 'components/molecules/paginationControl';
import { HTMLView } from 'components/atoms/htmlView';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  beers: Array<Beers>,
};

const BeerExplorer = (props: Props) => {
  const { beerData } = props.data;
  const { height, isMobile } = useViewport();
  const [sliderRef, setSlider] = useState();
  const [activeSlide, setActiveSlide] = useState(0);
  const [slideToMove, setSlideToMove] = useState(1);
  const length = beerData.length;
  let containerClass = 'beer-explorer section-container';
  if (isMobile) {
    containerClass = 'beer-explorer-mobile';
  }
  const next = () => {
    setSlideToMove(1);
    sliderRef.slickNext();
  };

  const previous = () => {
    setSlideToMove(1);
    sliderRef.slickPrev();
  };

  const settings = {
    className: 'slider variable-width',
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: slideToMove,
    variableWidth: !isMobile,
    speed: 1000,
    beforeChange: (current, next) => setActiveSlide(next),
    arrows: false,
    draggable: isMobile,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const imageClicked = idx => {
    if (idx !== activeSlide) {
      setActiveSlide(idx);
      setSlideToMove(idx);
      sliderRef.slickNext();
    }
  };

  const renderSlider = () => {
    return (
      <Slider ref={c => setSlider(c)} {...settings} style={{ height: '100%' }}>
        {beerData.map((item, idx) => {
          let margin = idx <= activeSlide ? '8.33334vw' : '0';
          let padding = idx > activeSlide ? '2.083335vw' : '0';
          let marginMobile = idx > activeSlide ? '15% 0 0 -8%' : '15% 0 0 1%';
          return !isMobile ? (
            <div className={'beer-card'} key={idx}>
              <div
                className={`beer-image ${idx >= activeSlide ? 'animate' : ''}`}
                style={{ marginRight: padding, cursor: 'pointer' }}
                onClick={() => imageClicked(idx)}
              >
                <Image src={item.image} alt={'card'} />
              </div>
              {idx <= activeSlide && (
                <div className={'beer-details'} style={{ marginRight: margin }}>
                  <h1>{item.name}</h1>
                  <h4>{item.restaurantName}</h4>
                  <HTMLView
                    className={'description'}
                    html={item.description}
                    tagName={'p'}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={'beer-card'} key={idx}>
              {idx <= activeSlide && (
                <div className={'beer-details'}>
                  <h1>{item.name}</h1>
                  <h4>{item.restaurantName}</h4>
                  <HTMLView
                    className={'description'}
                    html={item.descriptionMobile}
                    tagName={'p'}
                  />
                </div>
              )}
              <div
                className={`beer-image ${idx === activeSlide ? 'animate' : ''}`}
                style={{ margin: marginMobile }}
              >
                <img src={item.imageMobile} alt={'card'} />
              </div>
            </div>
          );
        })}
      </Slider>
    );
  };

  return (
    <div className={containerClass} style={{ height }} id={'beer-explorer'}>
      <div className={'carousel'}>{renderSlider()}</div>
      {!isMobile && (
        <div className={'section-footer show-explore'}>
          <PaginationControl
            className={'section-footer-item'}
            theme={'light-theme'}
            mode={'slider'}
            currentIndex={activeSlide + 1}
            total={length}
            onNextClick={next}
            onPreviousClick={previous}
          />
        </div>
      )}
    </div>
  );
};

export default BeerExplorer;
